import _ from 'lodash';
import { createAction, createReducer } from 'redux-act';
import moment from 'moment';

export const actions = {
  setActiveEvent: createAction('set active event'),
  setNewEvent: createAction('set new event'),
  clearNewEvent: createAction('clear new event'),
  clearActiveEvent: createAction('clear active event')
};

const getTime = date => moment(date).valueOf();

const initialState = {
  activeEventId: null,
  newEventId: null
};

const listenTo = {
  [actions.setActiveEvent]: (state, activeEventId) => ({
    ...state,
    activeEventId
  }),
  [actions.clearActiveEvent]: state => ({
    ...state,
    activeEventId: null
  }),
  [actions.setNewEvent]: (state, newEventId) => ({
    ...state,
    newEventId,
    activeEventId: null
  }),
  [actions.clearNewEvent]: state => ({
    ...state,
    newEventId: null
  })
};

export default createReducer(listenTo, initialState);



// WEBPACK FOOTER //
// ./src/reducers/schedule.js